import { PInputText } from 'components/prime/PInputText/PInputText';
import React from 'react';
import { useUploadStepBLoC } from '../../../../UploadStep.bloc';
import { TypeOfDataNameInputStyle as S } from './TypeOfDataNameInput.style';
import { VStack } from 'components/layouts/primitives/Stack/Stack';
import { Text } from 'components/Text/Text';
import { FormField } from 'components/FormField/FormField';

export const TypeOfDataNameInput: React.FC = () => {
  const { uploadForm } = useUploadStepBLoC();
  return (
    <S.Container>
      <FormField
        form={uploadForm}
        label="Project name"
        controller={{
          name: 'projectName',
          rules: {
            required: 'Name is required',
            maxLength: 255,
          },
        }}
      >
        {({ field, fieldState }) => (
          <VStack>
            <Text color="neutral400" size="fontSizeSM" lineHeight="lineHeightMD">
              Use a name that reflects your data
            </Text>
            <PInputText
              {...field}
              invalid={fieldState.invalid}
              placeholder="E.g. Employee NPS"
              maxLength={255}
              onBlur={() => field.onChange(field.value.trim())}
            />
          </VStack>
        )}
      </FormField>
    </S.Container>
  );
};
